import React, { useState, useEffect, useRef } from 'react';
import {
  Container, Typography, Button, Box, Input, Grid, TextField, MenuItem, Select, RadioGroup,
  Radio, Tooltip, IconButton, Breadcrumbs, FormGroup, Checkbox, Modal, Paper
} from '@mui/material';
import { handleSpaces, getErrorMessage } from "../utils/helper.js";
import closeIcon from "../assets/images/close-icon.svg";
import { danger, success } from '../utils/message-box.js';
import Size from "./Size.js";
import AmazonForm from "./AmazonForm.js";
import { ReactComponent as BacktoJob } from "../assets/images/back-to-jobs-black.svg";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { useLocation, useNavigate } from "react-router-dom";
import axios from 'axios';
import { format } from 'date-fns';
import axiosInstance from '../Services/axiosInstance.js';
import { getVendorContact } from '../utils/auth.js';
import { resolveVendorCommission } from '../utils/vendorCommission.js';
import InfoIcon from "@mui/icons-material/Info";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { useReactToPrint } from 'react-to-print';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import {
  CustomerFormSection,
  CustomerFormField,
  CustomerBorderedInput,
  CustomerBorderedTextarea,
} from '../utils/customerFormUi.js';

const GuestUserForm = () => {
  const label = { inputProps: { "aria-label": "Checkbox demo" } };
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const location = useLocation();
  const [customerName, setCustomerName] = useState("");
  const [nameError, setNameError] = useState("");
  const [invalidMobilePhoneError, setInvalidMobilePhoneError] = useState("");
  const [invalidMobilePhoneError1, setInvalidMobilePhoneError1] = useState("");
  const [duplicateNumber, setDuplicateNumber] = useState("");
  const [duplicateNumber1, setDuplicateNumber1] = useState("");
  const [errorStatus, setErrorStatus] = useState();
  const [errorStatus1, setErrorStatus1] = useState();
  const [mobileNumber, setMobileNumber] = useState("");
  const [altMobileNumber, setAltMobileNumber] = useState("");
  const [pincode, setPincode] = useState("");
  const [pinError, setPinError] = useState("");
  const [WeightError, setWeightError] = useState("");
  const [codError, setCodError] = useState("");
  const [prepaidError, setPrepaidError] = useState("");
  const [weight, setWeight] = useState("");
  const [codAmount, setCodAmount] = useState(0);
  const [barcode, setBarcode] = useState("");
  const [bighatId, setBighatId] = useState("");
  const [prepaidAmount, setPrepaidAmount] = useState("");
  const [aboutMeInfo, setAboutMeInfo] = useState("");
  const [barcodeError, setBarcodeError] = useState("");
  const [addressError, setAddressError] = useState("");
  const [businessType, setBusinessType] = useState('PO');
  const [commission, setCommission] = useState(0);
  const [commissionError, setCommissionError] = useState("");
  const [commissionReadOnly, setCommissionReadOnly] = useState(false);
  const [matchedVendor, setMatchedVendor] = useState(null);
  const [vendorLookupLoading, setVendorLookupLoading] = useState(false);
  const [unregisteredVendorError, setUnregisteredVendorError] = useState('');
  const [printModel, setPrintModel] = useState(false);
  const [sizeDetails, setSizeDetails] = useState([]);
  const [customerId, setCustomerId] = useState();
  const [openSnackbar, setOpenSnakbar] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [clearForm, setClearForm] = useState(false);
  const [createdDate, setCreatedDate] = useState(new Date());
  const [complaintNumber, setComplaintNumber] = useState("");
  const [transactionNumber, setTransactionNumber] = useState(null);
  const [isReturn, setIsReturn] = useState(false);
  const [orderType, setOrderType] = useState(false);
  const [duplicateId, setDuplicateId] = useState([]);
  const [buttonDisable, setButtonDisable] = useState(false);
  const hasCodAmount = Number(codAmount) > 0;
  const hasPrepaidAmount = Number(prepaidAmount) > 0;
  const getOrderAmount = () => {
    const prepaidValue = Number(prepaidAmount) || 0;
    const codValue = Number(codAmount) || 0;
    return prepaidValue > 0 ? prepaidValue : codValue;
  };
  const modalRef = useRef();
  const contentToPrint = useRef(null);
  const headers = {
    headers: {
      "Content-Type": "application/json",
      "Authorization": 'Bearer ' + localStorage.getItem('access-token')
    }
  };

  const clearData = () => {
    setCustomerName("");
    setMobileNumber("");
    setAltMobileNumber("");
    setPincode("");
    setAboutMeInfo("");
    setCustomerId("");
    setWeight("");
    setCodAmount(0);
    setBarcode("");
    setBighatId("");
    setPrepaidAmount("");
    setCommission(0);
    setCommissionReadOnly(false);
    setMatchedVendor(null);
    setVendorLookupLoading(false);
    setUnregisteredVendorError('');
    setSizeDetails([]);
    setClearForm(true);
    setBusinessType("PO");
    setComplaintNumber("");
    setIsReturn(false);
    setTransactionNumber(null);
  }
  const handleContactNo = (e) => {
    if (e.target.value.trim() === "") {
      setInvalidMobilePhoneError("");
    } else if (
      /^\d+(?: \d+)*$/.test(e.target.value) === false
    ) {
      setInvalidMobilePhoneError("Please enter valid phone number");
    } else if (e.target.value.length > 10) {
      setInvalidMobilePhoneError("Exceeded maximum character length of 10");
    } else if (e.target.value.length < 10) {
      setInvalidMobilePhoneError("Please enter valid phone number");
    } else {
      setInvalidMobilePhoneError("");
    }
    setMobileNumber(e.target.value.trimStart());
  };
  const handlePhoneNo = (e) => {
    if (e.target.value.trim() === "") {
      setInvalidMobilePhoneError1("");
    } else if (
      /^\d+(?: \d+)*$/.test(e.target.value) === false
    ) {
      setInvalidMobilePhoneError1("Please enter valid phone number");
    } else if (e.target.value.length > 10) {
      setInvalidMobilePhoneError1("Exceeded maximum character length of 10");
    } else if (e.target.value.length < 10) {
      setInvalidMobilePhoneError1("Please enter valid phone number");
    } else {
      setInvalidMobilePhoneError1("");
    }
    setAltMobileNumber(e.target.value.trimStart());
  };

  function getTotalQuantity(items) {
    return items.reduce((total, item) => total + Number(item.quantity), 0);
  };

  useEffect(() => {
    if (!matchedVendor) {
      setCommissionReadOnly(false);
      return;
    }

    const orderAmount = getOrderAmount();
    if (orderAmount <= 0) {
      setCommissionReadOnly(false);
      return;
    }

    const resolved = resolveVendorCommission(matchedVendor, sizeDetails, orderAmount);
    if (resolved === null) {
      setCommissionReadOnly(false);
      return;
    }
    setCommission(resolved);
    setCommissionError('');
    setCommissionReadOnly(true);
  }, [matchedVendor, sizeDetails, codAmount, prepaidAmount]);

  useEffect(() => {
    const vendorContact = getVendorContact();
    if (!vendorContact) return;

    setVendorLookupLoading(true);
    setUnregisteredVendorError('');

    axiosInstance
      .get('/api/v1/vendor/me')
      .then((res) => {
        const vendor = res.data?.data || null;
        if (vendor) {
          setMatchedVendor(vendor);
          setUnregisteredVendorError('');
        } else {
          setMatchedVendor(null);
          setUnregisteredVendorError('Seller profile not found. Please contact support.');
        }
      })
      .catch((error) => {
        setMatchedVendor(null);
        setUnregisteredVendorError(getErrorMessage(error, 'Unable to load seller profile.'));
      })
      .finally(() => {
        setVendorLookupLoading(false);
      });
  }, []);
  
  const Submit = () => {
    const phone = getVendorContact();
    if (vendorLookupLoading) {
      danger('Please wait while seller registration is verified.');
      return;
    }
    if (!matchedVendor || !phone || phone.length !== 10) {
      setUnregisteredVendorError('Seller profile not found. Please contact support.');
      danger('Order cannot be created. Seller profile must be registered — please contact support.');
      return;
    }

    let updatedPayloads = [];
    setButtonDisable(true);
    const orderAmount = getOrderAmount();
    const resolvedCommission = resolveVendorCommission(matchedVendor, sizeDetails, orderAmount);
    const payload = {
      "name": customerName || null,
      "address": aboutMeInfo.trimEnd() || null,
      "phone_number": mobileNumber || null,
      "alt_phone_number": altMobileNumber || null,
      "barcode": customerName.substring(0, 5) + Math.floor(Math.random() * (10000 + 1)) || null,
      "pincode": pincode || null,
      "created_at": format(createdDate, "yyyy-MM-dd"),
      "order_status": 'Pending',
      "delivary_charges": 0,
      "cod": codAmount ? codAmount : 0,
      "prepaid": prepaidAmount ? prepaidAmount : 0,
      "weight": weight || null,
      "bighat_order_id": bighatId ? bighatId : null,
      "commision": resolvedCommission !== null ? resolvedCommission : (commission || 0),
      "business_type": null,
      "created_by": phone,
      "order_quantity": getTotalQuantity(sizeDetails),
      "transaction_number": transactionNumber,
      "size_details": sizeDetails?.map(({ id, ...rest }) => ({
        ...rest
      }))
    }
    if (!['PSP', 'PBP', 'PO', 'OF', 'BH'].includes(businessType)) {
      updatedPayloads = sizeDetails?.map((data) => {
        return {
          ...payload,
          barcode: data.tracking_id,
          order_quantity: getTotalQuantity(data.products),
          size_details: data.products.map(pro => {
            return {
              "size": pro.size,
              "product_type": pro.product_type,
              "quantity": pro.quantity,
            }
          })
          // [{
          //     "size": data.size,
          //     "product_type": data.product_type,
          //     "quantity": data.quantity,
          // }]
        };
      });
    }
    axiosInstance.post('/api/v1/vendor/orders', payload)
      .then((res) => {
        clearData();
        setClearForm(true);
        setSizeDetails([]);
        setButtonDisable(false);
        success('Customer details saved successfully.');
        setTimeout(() => {
          window.scrollTo({ top: 0, behavior: "smooth" });
          // window.scrollTo({ top: document.body.scrollHeight, behavior: "smooth" });
        }, 0)
      }).catch((error) => {
        setButtonDisable(false);
        danger(getErrorMessage(error, 'Failed to save customer details. Please try again.'));
      });
  };
  function isAnyProductValueEmpty(array) {
    if (!array?.length) {
      return true;
    } else {
      return array?.some((obj) =>
        !obj.size ||
        !obj.product_type ||
        !obj.quantity
      );
    }
  };
  const isValidPostOfficeData = () => {
    // Check if codAmount has a value greater than 0 (0, "", null, undefined are not valid)
    const codValue = codAmount !== "" && codAmount !== null && codAmount !== undefined ? Number(codAmount) : 0;
    const hasCodValue = codValue > 0;
    
    // Check if prepaidAmount has a value greater than 0 (0, "", null, undefined are not valid)
    const prepaidValue = prepaidAmount !== "" && prepaidAmount !== null && prepaidAmount !== undefined ? Number(prepaidAmount) : 0;
    const hasPrepaidValue = prepaidValue > 0;
    
    // At least one of codAmount or prepaidAmount should have a value > 0
    const hasAtLeastOneAmount = hasCodValue || hasPrepaidValue;
    const hasBothAmounts = hasCodValue && hasPrepaidValue;
    
    const vendorContact = getVendorContact();
    const hasValidSeller = /^\d{10}$/.test(String(vendorContact || '').trim());
    const isSellerVendorBlocked =
      vendorLookupLoading ||
      !!unregisteredVendorError ||
      !hasValidSeller ||
      !matchedVendor;

    return nameError || pinError || codError || addressError || prepaidError ||
      (hasAtLeastOneAmount && commissionError) || invalidMobilePhoneError ||
      isSellerVendorBlocked ||
      !hasAtLeastOneAmount || hasBothAmounts || !aboutMeInfo || !pincode || !customerName ||
      !mobileNumber || isAnyProductValueEmpty(sizeDetails)
  };
  return (
    <>
      <Grid container item>
        <Grid
          item
          xs={12}
          sm={12}
          md={12}
          lg={12}
          sx={{ pb: 1, mt: 1 }}
          className="userBg-space resolution-view my-jobs-align project-preview-align screening-align myJobs-status galaxy-block galaxy-padding"
        >
          <>
            <Container
              maxWidth={false}
              className="guest-user-form customer-form-page"
            >
              <Typography>
              <Breadcrumbs
                aria-label="breadcrumb"
                className="pt-0 pb-10"
                separator={<NavigateNextIcon fontSize="small" aria-label="Next icon" />}
              >
                <span className="cursor-hover d-flex f-12 gray9 font-weight-600 text-decoration-none" onClick={() => navigate('/vendor/home')}>
                  <BacktoJob className="mr-10" />
                  Back to Home
                </span>
                {/* </Link> */}
              </Breadcrumbs>
            </Typography>
              <Box className="customer-form-page-header">
                <Typography className="customer-form-page-title">
                  Create New Order
                </Typography>
                <Typography className="customer-form-page-subtitle">
                  Fill in customer and order details below.
                </Typography>
              </Box>

              <Box>
                <CustomerFormSection
                  title="Customer Details"
                  subtitle="Enter customer contact information."
                >
                  <CustomerFormField label="Customer Name" required error={nameError}>
                    <CustomerBorderedInput
                      error={!!nameError}
                      placeholder="Customer full name"
                      value={customerName}
                      onKeyPress={handleSpaces}
                      onChange={(e) => {
                        setCustomerName(e.target.value);
                        if (e.target.value?.length > 128) {
                          setNameError('Exceeded maximum character length of 128');
                        } else {
                          setNameError('');
                        }
                      }}
                      inputProps={{ autoComplete: 'off', maxLength: 128 }}
                    />
                  </CustomerFormField>

                  <CustomerFormField
                    label="Phone Number"
                    required
                    error={
                      invalidMobilePhoneError || duplicateNumber ? (
                        <>
                          {invalidMobilePhoneError || duplicateNumber}{' '}
                          <Box
                            component="span"
                            sx={{
                              fontWeight: 600,
                              color:
                                errorStatus?.order_status === 'Returned'
                                  ? '#b54708'
                                  : errorStatus?.order_status === 'Delivered'
                                    ? '#027a48'
                                    : errorStatus?.order_status === 'Dispatched'
                                      ? '#027a48'
                                      : errorStatus?.order_status === 'Disputed'
                                        ? '#FFC107'
                                        : '#20B2AA',
                            }}
                          >
                            {errorStatus?.order_status}
                          </Box>
                        </>
                      ) : null
                    }
                  >
                    <CustomerBorderedInput
                      error={!!invalidMobilePhoneError}
                      icon={LocalPhoneIcon}
                      placeholder="10-digit phone number"
                      value={
                        mobileNumber?.split('-').length > 1
                          ? mobileNumber?.split('-')[1]
                          : mobileNumber?.split('-')[0]
                      }
                      onChange={handleContactNo}
                      inputProps={{ autoComplete: 'off', inputMode: 'numeric' }}
                    />
                    {errorStatus?.size_details?.map((skills, index) => (
                      <Box key={index} sx={{ mt: 1, display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                        <span className="skills text-initial font-weight-600 f-12">
                          {skills.product_type}-{skills.size} ({skills.quantity})
                        </span>
                      </Box>
                    ))}
                  </CustomerFormField>

                  <CustomerFormField
                    label="Alternative Phone Number"
                    error={
                      invalidMobilePhoneError1 || duplicateNumber1 ? (
                        <>
                          {invalidMobilePhoneError1 || duplicateNumber1}{' '}
                          <Box
                            component="span"
                            sx={{
                              fontWeight: 600,
                              color:
                                errorStatus1?.order_status === 'Returned'
                                  ? '#b54708'
                                  : errorStatus1?.order_status === 'Delivered'
                                    ? '#027a48'
                                    : errorStatus1?.order_status === 'Dispatched'
                                      ? '#027a48'
                                      : errorStatus1?.order_status === 'Disputed'
                                        ? '#FFC107'
                                        : '#20B2AA',
                            }}
                          >
                            {errorStatus1?.order_status}
                          </Box>
                        </>
                      ) : null
                    }
                  >
                    <CustomerBorderedInput
                      error={!!invalidMobilePhoneError1}
                      icon={LocalPhoneIcon}
                      placeholder="Alternative phone (optional)"
                      value={
                        altMobileNumber?.split('-').length > 1
                          ? altMobileNumber?.split('-')[1]
                          : altMobileNumber?.split('-')[0]
                      }
                      onChange={handlePhoneNo}
                      inputProps={{ autoComplete: 'off', inputMode: 'numeric' }}
                    />
                    {errorStatus1?.size_details?.map((skills, index) => (
                      <Box key={index} sx={{ mt: 1, display: 'flex', flexWrap: 'wrap', gap: 0.5 }}>
                        <span className="skills text-initial font-weight-600 f-12">
                          {skills.product_type}-{skills.size} ({skills.quantity})
                        </span>
                      </Box>
                    ))}
                  </CustomerFormField>
                </CustomerFormSection>

                <CustomerFormSection title="Delivery Details">
                  <CustomerFormField label="Address" required fullWidth error={addressError}>
                    <CustomerBorderedTextarea
                      rows={isMobile ? 6 : 8}
                      placeholder="Full delivery address"
                      error={!!addressError}
                      value={aboutMeInfo}
                      onKeyPress={handleSpaces}
                      onChange={(e) => {
                        if (e.target.value?.length === 1) {
                          setAboutMeInfo(e.target.value.toUpperCase());
                          return;
                        }
                        setAddressError('');
                        setAboutMeInfo(e.target.value);
                      }}
                      textareaProps={{
                        maxLength: 2000,
                        name: 'aboutme',
                        id: 'aboutme',
                      }}
                    />
                  </CustomerFormField>

                  <CustomerFormField label="Pincode" required error={pinError}>
                    <CustomerBorderedInput
                      error={!!pinError}
                      placeholder="6-digit pincode"
                      value={pincode}
                      onKeyPress={handleSpaces}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (!/^\d{6}$/.test(value)) {
                            setPinError('Please enter a valid pincode');
                        } else {
                            setPinError('');
                        }
                        setPincode(value);
                      }}
                      inputProps={{ autoComplete: 'off', inputMode: 'numeric', maxLength: 6 }}
                    />
                  </CustomerFormField>
                </CustomerFormSection>

                <Paper elevation={0} className="customer-form-embedded-section">
                  <Box className="customer-form-section-header">
                    <Typography className="customer-form-section-title">
                      Product Details
                    </Typography>
                  </Box>
                  <Box>
                    <Size
                      setSizeDetails={setSizeDetails}
                      sizeDetails={sizeDetails}
                      clearForm={clearForm}
                      setClearForm={setClearForm}
                      setWeight={setWeight}
                    />
                    <Box className="customer-form-total-row">
                      Total quantity: {getTotalQuantity(sizeDetails)}
                    </Box>
                  </Box>
                </Paper>

                <CustomerFormSection
                  title="Payment Details"
                  subtitle="Enter either COD or Prepaid amount — not both."
                >
                  <CustomerFormField label="COD" required mdCols={4} error={codError}>
                    <CustomerBorderedInput
                      error={!!codError}
                      placeholder="COD amount"
                      disabled={hasPrepaidAmount}
                      value={codAmount}
                      onKeyPress={handleSpaces}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (value?.length !== 0 && !/^\d+(?: \d+)*$/.test(value)) {
                          setCodError('Please enter a valid amount');
                          setCodAmount(value);
                        } else {
                          setCodAmount(value);
                          setCodError('');
                          if (Number(value) > 0) {
                            setPrepaidAmount('');
                            setPrepaidError('');
                          }
                        }
                      }}
                      inputProps={{ autoComplete: 'off', inputMode: 'numeric' }}
                    />
                  </CustomerFormField>

                  <CustomerFormField label="Prepaid" required mdCols={4} error={prepaidError}>
                    <CustomerBorderedInput
                      error={!!prepaidError}
                      placeholder="Prepaid amount"
                      disabled={hasCodAmount}
                      value={prepaidAmount}
                      onKeyPress={handleSpaces}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (value?.length !== 0 && !/^\d+(?: \d+)*$/.test(value)) {
                          setPrepaidError('Please enter a valid amount');
                          setPrepaidAmount(value);
                        } else {
                          setPrepaidAmount(value);
                          setPrepaidError('');
                          if (Number(value) > 0) {
                            setCodAmount('');
                            setCodError('');
                            setCommission(0);
                            setCommissionError('');
                            setCommissionReadOnly(false);
                          }
                        }
                      }}
                      inputProps={{ autoComplete: 'off', inputMode: 'numeric' }}
                    />
                  </CustomerFormField>

                  <CustomerFormField
                    label="Commission"
                    mdCols={4}
                    error={commissionError}
                    helper={commissionReadOnly ? 'Commission auto-filled from vendor rates and cannot be edited.' : null}
                  >
                    <CustomerBorderedInput
                      error={!!commissionError}
                      disabled={commissionReadOnly}
                      placeholder={commissionReadOnly ? 'Auto-calculated from vendor agreement' : 'Enter commission amount'}
                      value={commission}
                      onKeyPress={handleSpaces}
                      onChange={(e) => {
                        if (commissionReadOnly) return;
                        if (e.target.value?.length !== 0 && !/^\d+(?: \d+)*$/.test(e.target.value)) {
                          setCommissionError('Please enter a valid amount');
                          setCommission(e.target.value);
                        } else {
                          setCommission(e.target.value);
                          setCommissionError('');
                        }
                      }}
                      inputProps={{ autoComplete: 'off', readOnly: commissionReadOnly }}
                    />
                  </CustomerFormField>
                </CustomerFormSection>

                <Paper elevation={0} className="customer-form-footer">
                  <Box className="customer-form-footer-actions">
                    <Button
                      className="btn secondary-button customer-form-submit-btn"
                      aria-label="button"
                      fullWidth={isMobile}
                      onClick={() => clearData()}
                    >
                      Cancel
                    </Button>
                    <Button
                      className="btn primary-button customer-form-submit-btn"
                      aria-label="button"
                      fullWidth={isMobile}
                      disabled={isValidPostOfficeData() || buttonDisable}
                      onClick={() => Submit()}
                    >
                      Save Order
                    </Button>
                  </Box>
                </Paper>
              </Box>
            </Container>
          </>
        </Grid>
      </Grid>
    </>
  );
};

export default GuestUserForm;
